'use strict';
{


//----- FAQ -----//

const questions = document.querySelectorAll('.faq_item .question');

console.log(questions);


questions.forEach((question) => {
  question.addEventListener('click', () => {
    question.parentElement.classList.toggle('active');
  });
});





// ---- ここまで -----
}